import React from 'react';

import MainHeader from "./components/MainHeader";
import MainFooter from "./components/MainFooter";

import './styles/linkNYC.css';

function App(props: { component: React.ReactElement<any, string | React.JSXElementConstructor<any>> }) {
  return (
    <div className="app-container">
      <MainHeader/>
      {props.component}
      <MainFooter/>
    </div>
  );
}

export default App;
